import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Element, animateScroll as scroll } from "react-scroll";
import ReactGA from "react-ga4";
import { handleEventAnalytics } from "../../utilities/eventAnalytics";
import { trackCustomEvent } from "../../FacebookPixel";

const Footer = ({ privacy }) => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    const options = {
      duration: 0,
      smooth: true,
    };
    scroll.scrollToTop(options);
  };

  const handlePrivacy = () => {
    navigate("/privacy-policy");
  };

  const handleUseTerms = () => {
    navigate("/terms-of-use");
  };

  const handleProfessionalSignUp = () => {
    navigate("/signup/step/1");
  };

  const handleSignIn = () => {
    ReactGA.event(handleEventAnalytics("login"));
    trackCustomEvent("Professional Login", {});
    navigate("/signin");
  };

  const handleAdminSignIn = () => {
    navigate("/admin-signin");
  };

  const handleClick = (platform) => {
    ReactGA.event(handleEventAnalytics(platform));
    trackCustomEvent(platform, {});
  };

  return (
    <div className="bg-footerPrimary">
      <div className="container">
        <div className="">
          <div
            className={`xl:mr-0 pb-10 lg:pb-[70px] grid grid-cols-8 gap-[66px] lg:gap-5 max-md:gap-[50px] max-md:grid-cols-1 mx-12 sm:mx-0 ${
              privacy ? "pt-[70px]" : "pt-[100px] md:pt-[150px]"
            }`}
          >
            <div className="col-span-2">
              <h1 className="font-bold text-[18px] leading-[29px] lg:text-[16px] lg:leading-[26px] lg:mb-[20px] text-[#F1F4F6] mb-[30px]">
                Our Service
              </h1>
              <div className="font-[400] text-[16px] leading-[29px] lg:text-[16px] lg:leading-[26px] text-[#F1F4F6] flex flex-col gap-[10px]">
                <p
                  className="hover:cursor-pointer hover:text-primary"
                  onClick={scrollToTop}
                >
                  Connect with a Provider
                </p>
                <p
                  className="hover:cursor-pointer hover:text-primary"
                  onClick={scrollToTop}
                >
                  Access your Match Info
                </p>

                {/* <p className="hover:cursor-pointer hover:text-primary">
                  Access your Match Info
                </p> */}
              </div>
            </div>

            <div className="col-span-2">
              <h1 className="font-bold text-[18px] leading-[29px] lg:text-[16px] lg:leading-[26px] lg:mb-[20px] text-[#F1F4F6] mb-[30px]">
                For Professionals
              </h1>
              <div className="font-[400] text-[16px] leading-[29px] lg:text-[16px] lg:leading-[26px] text-[#F1F4F6] flex flex-col gap-[10px]">
                <p
                  className="hover:cursor-pointer hover:text-primary"
                  onClick={handleProfessionalSignUp}
                >
                  Join Our Network&nbsp;
                </p>
                <p
                  className="hover:cursor-pointer hover:text-primary"
                  onClick={handleSignIn}
                >
                  Log In
                </p>
                <p className="hover:cursor-pointer hover:text-primary">
                  Mobile App (coming soon)
                </p>
              </div>
            </div>

            <div className="col-span-2">
              <h1 className="font-bold text-[18px] leading-[29px] lg:text-[16px] lg:leading-[26px] lg:mb-[20px] text-[#F1F4F6] mb-[30px]">
                Resources
              </h1>
              <div className="font-[400] text-[16px] leading-[29px] lg:text-[16px] lg:leading-[26px] text-[#F1F4F6] flex flex-col gap-[10px]">
                <p className="hover:cursor-pointer hover:text-primary">
                  Hiring the Right Health Professional
                </p>
                <p className="hover:cursor-pointer hover:text-primary">
                  Insurance Resource Center
                </p>
                <p className="hover:cursor-pointer hover:text-primary">FAQs</p>
              </div>
            </div>

            <div className="col-span-2">
              <h1 className="font-bold text-[18px] leading-[29px] lg:text-[16px] lg:leading-[26px] lg:mb-[20px] text-[#F1F4F6] mb-[30px]">
                Company&nbsp;
              </h1>
              <div className="font-[400] text-[16px] leading-[29px] lg:text-[16px] lg:leading-[26px] text-[#F1F4F6] flex flex-col gap-[10px]">
                <Link
                    to="/about-us"
                    className="hover:cursor-pointer hover:text-primary"
                  >
                    About Us
                  </Link>
                <p className="hover:cursor-pointer hover:text-primary">
                  Contact Us
                </p>
                <div className="hover:cursor-pointer hover:text-primary flex flex-row gap-5 mt-[20px]">
                  <Link
                    className="hover:cursor-pointer fill-white hover:fill-primary"
                    to={"https://" + "facebook.com/helpmatch?utm_source=hm-footer"}
                    target="_blank"
                    onClick={() => handleClick("facebook")}
                    title={"Facebook"}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Layer_1"
                      data-name="Layer 1"
                      width="24"
                      height="24"
                      version="1.1"
                      viewBox="0 0 24 24"
                    >
                      <defs></defs>
                      <path
                        className="cls-1"
                        d="M14.3,22.8h-5.3v-8.5h-3.4v-5.1h3.4v-2.4c0-.2,0-2.3,1.6-3.9,1.1-1.1,2.7-1.7,4.7-1.7.8,0,1.7,0,2.5.2h.6v4.7h-2.2c-.6,0-1.3,0-1.5.2,0,0,0,0,0,0-.2.2-.3.3-.3.4v2.4h3.9l-.5,5.1h-3.3v8.5ZM10.4,21.5h2.7v-8.5h3.4l.3-2.5h-3.7v-3.7c0-.8.5-1.2.8-1.4,0,0,0,0,0,0h0c.3-.3,1.1-.5,2.3-.5h.9v-2.2c-.6,0-1.1-.1-1.7-.1-1.6,0-2.9.4-3.7,1.3-1.2,1.2-1.2,2.9-1.2,2.9h0v3.7h-3.4v2.5h3.4v8.5Z"
                      />
                    </svg>
                  </Link>

                  <Link
                    className="hover:cursor-pointer fill-white hover:fill-primary"
                    to={"https://" + "linkedin.com/company/helpmatch?utm_source=hm-footer"}
                    target="_blank"
                    onClick={() => handleClick("linkedin")}
                    title={"Linkedin"}
                  >
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      version="1.1"
                      viewBox="0 0 24 24"
                    >
                      <defs></defs>
                      <path
                        className="cls-1"
                        d="M17.2,8.4c-.9,0-1.8.2-2.6.6-.1-.4-.5-.6-.9-.6h-4c-.6,0-1,.4-1,1h0v12c0,.6.4,1,1,1h4c.6,0,1-.4,1-1h0v-5.5c0-.6.4-1,1-1s1,.4,1,1v5.5c0,.6.4,1,1,1h4c.6,0,1-.4,1-1h0v-7.5c0-3-2.5-5.5-5.5-5.5ZM20.7,20.4h-2v-4.5c0-1.7-1.3-3-3-3s-3,1.3-3,3v4.5h-2v-10h2v.7c0,.6.4,1,1,1,.3,0,.6-.1.8-.4,1.2-1.5,3.4-1.8,4.9-.6.8.7,1.3,1.7,1.3,2.8v6.5ZM6.7,8.4H2.7c-.6,0-1,.4-1,1,0,0,0,0,0,0v12c0,.6.4,1,1,1h4c.6,0,1-.4,1-1h0v-12c0-.6-.4-1-1-1,0,0,0,0,0,0ZM5.7,20.4h-2v-10h2v10ZM4.7,1c-1.8-.1-3.3,1.3-3.4,3-.1,1.8,1.3,3.3,3,3.4.1,0,.2,0,.3,0h0c1.8.1,3.3-1.3,3.4-3,.1-1.8-1.3-3.3-3-3.4-.1,0-.2,0-.4,0h0ZM4.7,5.4h0c-.7,0-1.3-.4-1.4-1.1,0,0,0-.1,0-.2,0-.7.6-1.2,1.4-1.2.7,0,1.3.4,1.4,1.1,0,0,0,.1,0,.2,0,.7-.6,1.2-1.4,1.2Z"
                      />
                    </svg>
                  </Link>
                  <Link
                    className="hover:cursor-pointer fill-white hover:fill-primary"
                    to={"https://" + "x.com/helpmatch_?utm_source=hm-footer"}
                    target="_blank"
                    onClick={() => handleClick("x")}
                    title={"X"}
                  >
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      version="1.1"
                      viewBox="0 0 24 24"
                    >
                      <defs></defs>
                      <path
                        className="cls-1"
                        d="M14.1,10.3L22.1.9h-1.9l-7,8.1L7.6.9H1.2l8.4,12.3L1.2,23.1h1.9l7.4-8.6,5.9,8.6h6.4l-8.8-12.8h0ZM11.4,13.3l-.9-1.2L3.8,2.4h2.9l5.5,7.9.9,1.2,7.1,10.2h-2.9l-5.8-8.3h0Z"
                      />
                    </svg>
                  </Link>
                  <Link
                    className="hover:cursor-pointer fill-white hover:fill-primary"
                    to={"https://" + "instagram.com/helpmatch?utm_source=hm-footer"}
                    target="_blank"
                    onClick={() => handleClick("instagram")}
                    title={"Instagram"}
                  >
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      version="1.1"
                      viewBox="0 0 24 24"
                    >
                      <defs></defs>
                      <path
                        className="cls-1"
                        d="M16,3.4c2.5,0,4.6,2.1,4.6,4.6v8c0,2.5-2.1,4.6-4.6,4.6h-8c-2.5,0-4.6-2.1-4.6-4.6v-8c0-2.5,2.1-4.6,4.6-4.6h8M16,1.7h-8c-3.5,0-6.3,2.8-6.3,6.3v8c0,3.5,2.8,6.3,6.3,6.3h8c3.5,0,6.3-2.8,6.3-6.3v-8c0-3.5-2.8-6.3-6.3-6.3Z"
                      />
                      <path
                        className="cls-1"
                        d="M17.5,5.3c-.7,0-1.2.5-1.2,1.2s.5,1.2,1.2,1.2c.7,0,1.2-.5,1.2-1.2s-.5-1.2-1.2-1.2h0Z"
                      />
                      <path
                        className="cls-1"
                        d="M12.1,8.3c2,0,3.7,1.7,3.7,3.7,0,2-1.7,3.7-3.7,3.7-2,0-3.7-1.7-3.7-3.7,0,0,0,0,0,0,0-2,1.7-3.7,3.7-3.7M12.1,6.7c-3,0-5.4,2.4-5.4,5.4,0,3,2.4,5.4,5.4,5.4,3,0,5.4-2.4,5.4-5.4,0-3-2.4-5.4-5.4-5.4,0,0,0,0,0,0Z"
                      />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-footerSecondary text-center font-medium text-[14px] leading-[22px] text-bodyColor m-0 pt-[21px] pb-[20px]">
        <div className="container flex justify-center flex-wrap">
          <p className="sm:m-0 mb-2">
            © Copyright HelpMatch LLC. All Rights Reserved.
          </p>
          <p>
            <span
              onClick={handlePrivacy}
              className="ml-5 mr-5 xl:mr-[20px] hover:cursor-pointer hover:text-primary"
            >
              Privacy Policy&nbsp;
            </span>
            <span
              onClick={handleUseTerms}
              className="hover:cursor-pointer hover:text-primary"
            >
              Terms of Use
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
